import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input, Select, Checkbox } from 'semantic-ui-react'

import constants from '../../constants'

const options = [
  { key: 'm', text: 'Male', value: 'Male' },
  { key: 'f', text: 'Female', value: 'Female' },
  { key: 'o', text: 'Other', value: 'Other' },
]

const optionsEmployment = [
  { key: 'f', text: 'Full time', value: 'Full time' },
  { key: 'p', text: 'Part-time', value: 'Part-time' }
]

const optionsUserType = [
  { key: 'admin', text: 'Administrator', value: 'admin' },
  { key: 'principal', text: 'Principal', value: 'principal' },
  { key: 'registrar', text: 'Registrar', value: 'registrar' },
  { key: 'levelHead', text: 'Level Head', value: 'levelHead' },
  { key: 'teacher', text: 'Subject Teacher', value: 'teacher' },
  { key: 'adviser', text: 'Adviser', value: 'adviser' },
  { key: 'cashier', text: 'Cashier', value: 'cashier' },
  { key: 'staff', text: 'Admin Staff', value: 'staff' }
]

class TeachersAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      middleName: '',
      lastName: '',
      extensionName: '',
      birthDate: '',
      gender: '',
      address: '',
      email: '',
      contactNumber: '',
      employmentType: '',
      yearsOfTeaching: '',
      yearsOfTeachingSALIS: '',
      degreeEarned: '',
      username: '',
      password: '',
      type: '',
      level: 'NA',
      showModal: false,
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = () => {
    const data = {
      firstName: this.state.firstName,
      middleName: this.state.middleName,
      lastName: this.state.lastName,
      extensionName: this.state.extensionName,
      birthDate: this.state.birthDate,
      gender: this.state.gender,
      address: this.state.address,
      email: this.state.email,
      contactNumber: this.state.contactNumber,
      employmentType: this.state.employmentType,
      yearsOfTeaching: this.state.yearsOfTeaching,
      yearsOfTeachingSALIS: this.state.yearsOfTeachingSALIS,
      degreeEarned: this.state.degreeEarned,
      username: this.state.username,
      password: this.state.password,
      type: this.state.type,
      managesClubs: Boolean(this.state.managesClubs),
      level: this.state.level
    };
    this.props.handleSubmit(data);
    this.setState({
      firstName: '',
      middleName: '',
      lastName: '',
      extensionName: '',
      birthDate: '',
      gender: '',
      address: '',
      email: '',
      contactNumber: '',
      employmentType: '',
      yearsOfTeaching: '',
      yearsOfTeachingSALIS: '',
      degreeEarned: '',
      username: '',
      password: '',
      type: '',
      level: 'NA'
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  render() {
    const optionsLevelType = constants.levelType;
    return (
      <Modal
        trigger={
          <Button icon labelPosition='right' color='green' onClick={this.openModal}> <Icon name='add' />
          Add Teacher
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Add a Teacher</Modal.Header>
        <Modal.Content>
        <Form>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.firstName} name='firstName' label='First name' placeholder='First name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.middleName} name='middleName' label='Middle name' placeholder='Middle name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.lastName} name='lastName' label='Last name' placeholder='Last name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.extensionName} name='extensionName' label='Extension name' placeholder='Extension name' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field>
              <label>Birthdate</label>
              <Input value={this.state.birthDate} name='birthDate' type='date' placeholder='Birthdate' onChange={this.handleChange}/>
            </Form.Field>
            <Form.Field value={this.state.gender} name='gender' control={Select} label='Gender' options={options} placeholder='Gender' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.email} name='email' label='Email' placeholder='Email' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.contactNumber} name='contactNumber' label='Contact Number' placeholder='Contact Number' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Field value={this.state.address} name='address' control={Input} label='Address' placeholder='Address' onChange={this.handleChange}/>
          <Form.Group widths='equal'>
            <Form.Field value={this.state.employmentType} name='employmentType' control={Select} label='Employment Type' options={optionsEmployment} placeholder='Employment Type' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.degreeEarned} name='degreeEarned' label='Degree Earned' placeholder='Degree Earned' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.yearsOfTeaching} name='yearsOfTeaching' label='Years Of Teaching' placeholder='Years Of Teaching' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.yearsOfTeachingSALIS} name='yearsOfTeachingSALIS' label='Years Of Teaching in SALIS' placeholder='Years Of Teaching in SALIS' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.username} name='username' label='Username' placeholder='Username' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.password} name='password' label='Password' placeholder='Password' onChange={this.handleChange} type='password'/>
            <Form.Field value={this.state.type} name='type' control={Select} label='User Type' options={optionsUserType} placeholder='User Type' onChange={this.handleChange}/>
            <Form.Select
              fluid
              name='level'
              label='Level Type'
              placeholder='Level Type'
              options={optionsLevelType}
              onChange={this.handleChange}
              value={this.state.level}
            />
          </Form.Group>
            <Form.Group>
              {/* Its own row, and not a user type: a club moderator is usually a
                  subject teacher too, and replacing their type would take their
                  classes away. Squeezed into the equal-width row above it wrapped
                  over four lines and read as part of the User Type field. */}
              <Form.Field
                control={Checkbox}
                name='managesClubs'
                label='Student Activity Moderator (may create clubs and manage who is in them)'
                checked={Boolean(this.state.managesClubs)}
                onChange={(e, { name, checked }) => this.setState({ [name]: checked })}
              />
            </Form.Group>
        </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default TeachersAdd;
